import { Radio, RadioGroup, Grid } from '@mui/material';
import React from 'react';
import FolioCheckbox from '../FolioCheckbox';

const getGridSize = (count) => {
	if (count % 4 === 0) return 3; // 4 columns
	if (count % 3 === 0) return 4; // 3 columns
	if (count % 2 === 0) return 6; // 2 columns

	// Fallbacks
	if (count > 4) return 3;
	if (count > 2) return 4;
	return 6;
};

const FolioRadioGroup = ({ name, value, onChange, disabled = false, items }) => {
	const gridSize = getGridSize(items.length);

	return (
		<RadioGroup
			row
			name={name}
			value={value}
			onChange={onChange}
			sx={{
				width: '100%',
				display: 'flex',
				flexWrap: 'wrap',
			}}
		>
			<Grid container sx={{ width: '100%' }} rowSpacing={1} columnSpacing={2}>
				{items.map((item) => (
					<Grid size={{ xs: 12, sm: gridSize }} key={item?.value}>
						<FolioCheckbox
							component={Radio}
							value={item?.value}
							checked={String(item?.value) === String(value)}
							onChange={onChange}
							label={item?.label}
							disabled={item?.disabled ?? disabled}
							controlProps={{ value: item?.value }}
						/>
					</Grid>
				))}
			</Grid>
		</RadioGroup>
	);
};

export default FolioRadioGroup;
